import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import { ILocation } from '../types/appt_interfaces';

export interface IAppointmentsLocationsDatasource {
  locations: ILocation[];
  selectedLocation: ILocation;
  hasLocations: boolean;
  allowedLocations: ILocation[];
}

export class AppointmentsLocationsDatasource implements IDatasource {
  private _source: IAppointmentsLocationsDatasource = {
    locations: [],
    selectedLocation: {} as ILocation,
    hasLocations: true,
    allowedLocations: []
  };

  constructor() {
    this.initialize();
  }

  initialize(): AppointmentsLocationsDatasource {
    this._source = {
      locations: [],
      selectedLocation: {} as ILocation,
      hasLocations: true,
      allowedLocations: []
    };
    return this;
  }

  write(raw: any): AppointmentsLocationsDatasource {
    this._source = {
      locations: _.sortBy(raw, 'name'),
      selectedLocation: {} as ILocation,
      hasLocations: !_.isEmpty(raw),
      allowedLocations: _.sortBy(_.filter(raw, 'allow_student_to_request_advising_appointments', true), 'name')
    };
    return this;
  }

  setSelectedLocation(location: ILocation): void {
    this._source.selectedLocation = location;
  }

  read(): IAppointmentsLocationsDatasource {
    return this._source;
  }

  clear(): void {
    this.initialize();
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this._source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/datasources/appointments_locations_datasource.ts